import { axiosInstance as axios } from './axios';
import { ILogin, ILoginResponse } from '@shared-components/models';
import { API_URL } from '@moxie/constants';

const login = (body: ILogin): Promise<ILoginResponse> => {
  return axios.post(`${process.env.NX_BASE_URL}${API_URL.ADMIN_LOGIN}`, body);
};

export { login };
